import { cn } from '@/lib/utils';
import { formatHourMark, useTimeFormat } from '@/shared/lib/time-format';

/**
 * TimeLabel — Atom
 * Hour marker displayed in the calendar time gutter.
 * In the current time format (shared/lib/time-format): 13 → "13:00" (24h, the standard) or "1p".
 */

interface TimeLabelProps {
  hour: number;
  className?: string;
}


export function TimeLabel({ hour, className }: TimeLabelProps) {
  const format = useTimeFormat();
  return (
    <span className={cn('text-xs text-[var(--color-text-subtle)] leading-none', className)}>
      {formatHourMark(hour, format)}
    </span>
  );
}
